import { lazy } from 'react';

// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';
import OperatorHeader from '../ui-component/header/OperatorHeader';

// dashboard routing
const PanelSupervisor = Loadable(lazy(() => import('views/pages/panel/PanelSupervisor')));
const AssignPage = Loadable(lazy(() => import('views/pages/supervisor/AssignPage')));
const EditRequestsResolutionPage = Loadable(lazy(() => import('views/pages/supervisor/EditRequestsResolutionPage')));
const SupervisorDashboardPage = Loadable(lazy(() => import('views/pages/supervisor/SupervisorDashboardPage')));

// Support pages
const SupportIncidentsPage = Loadable(lazy(() => import('views/pages/support/SupportIncidentsPage')));
const IncidentDetailPage = Loadable(lazy(() => import('views/pages/support/IncidentDetailPage')));

const Profile = Loadable(lazy(() => import('views/pages/users/profile/Profile')));
const EditDistributionList = Loadable(lazy(() => import('views/pages/operator/EditDistributionList')));

//Extras
// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
    path: '/',
    element: <OperatorHeader />,
    children: [
        {
            path: '/',
            element: <PanelSupervisor />
        },
        {
            path: '/profile',
            element: <Profile />
        },
        {
            path: '/supervisor',
            children: [
                {
                    path: 'assign-production',
                    element: <AssignPage />
                },
                {
                    path: 'edition-requests',
                    element: <EditRequestsResolutionPage />
                },
                {
                    path: 'dashboard',
                    element: <SupervisorDashboardPage />
                },
                {
                    path: 'edition-requests/detail',
                    element: <EditDistributionList />
                }
            ]
        },

        {
            path: '/support',
            children: [
                {
                    path: '',
                    element: <SupportIncidentsPage />
                },
                {
                    path: 'incident/:id',
                    element: <IncidentDetailPage />
                }
            ]
        },
        {
            path: '*',
            element: <PanelSupervisor />
        }
    ]
};

export default MainRoutes;
